import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";

import { Translate } from "react-redux-i18n";

class ToggleButtonRow extends PureComponent {
  render() {
    const row = this.props.topBtn.buttons.map((btn, idx) => {
      return (
        <ToggleButton
          key={btn.name}
          type="checkbox"
          name={btn.name}
          variant="secondary"
          checked={btn.checked}
          onMouseDown={this.props.onMouseDown}
          onMouseMove={this.props.onMouseMove}
        >
          {(btn.name + "").padStart(this.props.label ? 2 + this.props.label.length : 2, "0")}
        </ToggleButton>
      );
    });
    if (this.props.topBtn)
      row.unshift(
        <ToggleButton
          key={this.props.topBtn.name}
          type="checkbox"
          name={this.props.topBtn.name}
          variant="primary"
          checked={this.props.topBtn.checked}
          onChange={this.props.onTopBtnChange}
        >
          <Translate value={this.props.topBtn.label} />
        </ToggleButton>
      );
    return (
      <ButtonGroup key={row.name} onMouseUp={this.props.onMouseUp} vertical>
        {row}
      </ButtonGroup>
    );
  }
}

ToggleButtonRow.propTypes = {
  topBtn: PropTypes.object.isRequired,
};

export default ToggleButtonRow;
